import { createClient } from '@supabase/supabase-js';

// Validar que las variables de entorno existan
if (!process.env.REACT_APP_SUPABASE_URL) {
  throw new Error('REACT_APP_SUPABASE_URL no está definida');
}

if (!process.env.REACT_APP_SUPABASE_ANON_KEY) {
  throw new Error('REACT_APP_SUPABASE_ANON_KEY no está definida');
}

if (!process.env.REACT_APP_SUPABASE_SERVICE_ROLE_KEY) {
  throw new Error('REACT_APP_SUPABASE_SERVICE_ROLE_KEY no está definida');
}

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
const supabaseServiceKey = process.env.REACT_APP_SUPABASE_SERVICE_ROLE_KEY;

// Cliente regular para operaciones normales
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  },
  db: {
    schema: 'public'
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  }
});

// Cliente admin para operaciones que requieren service_role
export const supabaseAdmin = createClient(supabaseUrl, supabaseServiceKey);
